
export const VALID_NAME_MIN_LENGTH = 3;
export const VALID_OTP_MAX_LENGTH = 4;
export const verificationCooldownTime = 30;
// export const ALLOW_PRODUCT_COMPARE = JSON.parse(process.env.NEXT_PUBLIC_DEFAULT_SITES || false) || appConfig.isGrassdoor;
export const ALLOW_PRODUCT_COMPARE = true